// extracted by mini-css-extract-plugin
module.exports = {"modalHeaderContainer":"styles_modalHeaderContainer__2cB8j","arrow":"styles_arrow__2yDsP","label":"styles_label__38OTn"};